import * as React from 'react';
import Checkbox from 'src/components/FormElements/Checkbox';
import { ITheme } from 'src/Entities/Theme';
import { getThemes } from 'src/helpers/api';


type ThemeSelectProps = {
  value: number[];
  onChange: (value: number[]) => void;
};

const ThemeSelect = ({ value, onChange }: ThemeSelectProps) => {  
  const [themes, setThemes] = React.useState<ITheme[]>([]);

  React.useEffect(() => {
    getThemes().then(setThemes)
  }, []);

  return (
    <div className="flex flex-column">
      {themes.map((theme) => (
        <Checkbox
          key={theme.themeId}
          className="mt1"
          checked={value.indexOf(theme.themeId) !== -1}
          onChange={() => {
            const index = value.indexOf(theme.themeId);
            if (index > -1) {
              const withoutId = value.filter((id) => id !== theme.themeId);
              onChange(withoutId);
            } else {
              onChange(value.concat(theme.themeId));
            }
          }}
        >
          {theme.name}
        </Checkbox>
      ))}
    </div>
  );
}

export default ThemeSelect;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/ThemeSelect.tsx